/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_TitleInputs */

const en_about_title = /** @type {(inputs: About_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About Alchema`)
};

const de_about_title = /** @type {(inputs: About_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ueber Alchema`)
};

const fr_about_title = /** @type {(inputs: About_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À propos d'Alchema`)
};

const es_about_title = /** @type {(inputs: About_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobre Alchema`)
};

const it_about_title = /** @type {(inputs: About_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informazioni su Alchema`)
};

const nl_about_title = /** @type {(inputs: About_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Over Alchema`)
};

const pl_about_title = /** @type {(inputs: About_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O Alchema`)
};

const fi_about_title = /** @type {(inputs: About_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tietoa Alchemasta`)
};

const da_about_title = /** @type {(inputs: About_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om Alchema`)
};

const sv_about_title = /** @type {(inputs: About_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om Alchema`)
};

/**
* | output |
* | --- |
* | "About Alchema" |
*
* @param {About_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const about_title = /** @type {((inputs?: About_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_about_title(inputs)
	if (locale === "fr") return fr_about_title(inputs)
	if (locale === "es") return es_about_title(inputs)
	if (locale === "it") return it_about_title(inputs)
	if (locale === "nl") return nl_about_title(inputs)
	if (locale === "pl") return pl_about_title(inputs)
	if (locale === "fi") return fi_about_title(inputs)
	if (locale === "da") return da_about_title(inputs)
	if (locale === "sv") return sv_about_title(inputs)
	return en_about_title(inputs)
});